import http from '@/core/http/index';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import * as Types from './types';

/**
 * 列表
 * @see https://yapi.textile-story.com/project/1259/interface/api/92067
 *
 * @请求方法: GET
 * @请求地址: /ufg/web/admin/sys-param/page
 * @更新时间: 2023-07-21 10:08:13
 */
export const getSysParamPageApi = (params: Types.GetSysParamPageApiReq) => {
  return http.get<Types.GetSysParamPageApiRes>({
    url: '/ufg/web/admin/sys-param/page',
    params,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 详情
 * @see https://yapi.textile-story.com/project/1259/interface/api/92075
 *
 * @请求方法: GET
 * @请求地址: /ufg/web/admin/sys-param/detail/{paramId}
 * @更新时间: 2023-07-21 10:08:13
 */
export const getSysParamDetailApi = (paramId: string) => {
  return http.get<Types.SysParamResItem>({
    url: `/ufg/web/admin/sys-param/detail/${paramId}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 保存
 * @see https://yapi.textile-story.com/project/1259/interface/api/92083
 *
 * @请求方法: POST
 * @请求地址: /ufg/web/admin/sys-param/save
 * @更新时间: 2023-07-21 10:08:13
 */
export const postSysParamSaveApi = (data: Types.PostSysParamSaveApiReq) => {
  return http.post({
    url: '/ufg/web/admin/sys-param/save',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
